import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertTriangle, Home, ArrowLeft, RefreshCw } from 'lucide-react';
;

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Log the 404 for monitoring
    try {
      // Sanitize data before logging
      // const sanitizedPath = location.pathname.replace(/[<>"']/g, '').replace(/&/g, '&amp;').substring(0, 100);
      // const sanitizedSearch = location.search.replace(/[<>"']/g, '').replace(/&/g, '&amp;').substring(0, 100);
      // const sanitizedReferrer = document.referrer.replace(/[<>"']/g, '').replace(/&/g, '&amp;').substring(0, 100);
      
      // logging removed
    } catch {
      // Error handled silently
    }
  }, [location]);

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/', { replace: true });
    }
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="flex items-center justify-center min-h-screen p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
            <AlertTriangle className="w-8 h-8 text-orange-600" />
          </div>
          <CardTitle className="text-2xl">Page Not Found</CardTitle>
          <CardDescription>
            The page you're looking for doesn't exist or may have been moved.
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-4">
          <Alert>
            <AlertTriangle className="h-4 w-4" />
            <AlertTitle>What happened?</AlertTitle>
            <AlertDescription>
              You tried to access <code className="px-1 py-0.5 bg-gray-100 rounded text-sm">{location.pathname}</code> 
              {' '}but this route doesn't exist in ShiftSage.
            </AlertDescription>
          </Alert>

          <div className="space-y-2">
            <p className="text-sm text-gray-600">Here's what you can do:</p>
            <div className="flex flex-col space-y-2">
              <Button onClick={handleGoHome} variant="secondary" className="w-full">
                <Home className="w-4 h-4 mr-2" />
                Go to Dashboard
              </Button>
              
              <Button onClick={handleGoBack} variant="outline" className="w-full">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Go Back
              </Button>
              
              <Button onClick={handleRefresh} variant="outline" className="w-full">
                <RefreshCw className="w-4 h-4 mr-2" />
                Refresh Page
              </Button>
            </div>
          </div>

          <div className="pt-4 border-t">
            <p className="text-xs text-gray-500 text-center">
              If you believe this is an error, please contact your system administrator.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound; 